﻿const initCustomBanners = () => {
  const banners = document.querySelectorAll('[data-custom-banner]');

  banners.forEach((banner) => {
    const slider = banner.querySelector('.custom-banner__slider');

    if (!slider || typeof Splide === 'undefined' || slider.classList.contains('is-initialized')) {
      return;
    }

    const slideCount = slider.querySelectorAll('.splide__slide').length;

    if (slideCount <= 1) {
      return;
    }

    const autoplay = banner.dataset.autoplay === 'true' && slideCount > 1;
    const speed = Number.parseInt(banner.dataset.speed, 10) || 900;
    const interval = Number.parseInt(banner.dataset.interval, 10) || 5000;

    new Splide(slider, {
      type: 'loop',
      arrows: false,
      pagination: true,
      autoplay,
      interval,
      speed,
      pauseOnHover: true,
      pauseOnFocus: true,
      drag: true,
      perPage: 1,
      perMove: 1,
      keyboard: 'global',
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: false,
      },
    }).mount();
  });
};

document.addEventListener('DOMContentLoaded', initCustomBanners);
document.addEventListener('shopify:section:load', initCustomBanners);

const initCustomFaqAccordions = (root = document) => {
  root.querySelectorAll('.custom-faq-section').forEach((section) => {
    if (section.dataset.faqInitialized === 'true') {
      return;
    }

    const items = Array.from(section.querySelectorAll('.faq-item'));

    if (!items.length) {
      return;
    }

    const closeItem = (item) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      item.classList.remove('active');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }

      if (answer) {
        answer.style.height = '0px';
      }
    };

    const openItem = (item) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      item.classList.add('active');

      if (button) {
        button.setAttribute('aria-expanded', 'true');
      }

      if (answer) {
        answer.style.height = `${answer.scrollHeight}px`;
      }
    };

    items.forEach((item) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      if (!button || !answer) {
        return;
      }

      button.type = 'button';
      button.addEventListener('click', () => {
        const shouldOpen = !item.classList.contains('active');

        items.forEach(closeItem);

        if (shouldOpen) {
          openItem(item);
        }
      });
    });

    const activeItem = items.find((item) => item.classList.contains('active')) || items[0];

    items.forEach(closeItem);
    openItem(activeItem);

    window.addEventListener('resize', () => {
      const openAnswer = section.querySelector('.faq-item.active .faq-answer');

      if (openAnswer) {
        openAnswer.style.height = `${openAnswer.scrollHeight}px`;
      }
    });

    section.dataset.faqInitialized = 'true';
  });
};

document.addEventListener('DOMContentLoaded', () => initCustomFaqAccordions());
document.addEventListener('shopify:section:load', (event) => initCustomFaqAccordions(event.target));

const initContactBottomIcons = (root = document) => {
  root.querySelectorAll('.cont_bottom').forEach((container) => {
    if (container.dataset.contactBottomReady === 'true') {
      return;
    }

    container.querySelectorAll('p').forEach((paragraph) => {
      if (!paragraph.querySelector('br')) {
        return;
      }

      const rows = [];
      let currentRow = [];

      Array.from(paragraph.childNodes).forEach((node) => {
        if (node.nodeName === 'BR') {
          if (currentRow.length) {
            rows.push(currentRow);
            currentRow = [];
          }
          return;
        }

        currentRow.push(node);
      });

      if (currentRow.length) {
        rows.push(currentRow);
      }

      if (rows.length < 2) {
        return;
      }

      const items = document.createElement('div');
      items.className = 'cont_bottom__items';

      rows.forEach((row) => {
        const item = document.createElement('div');
        const rowText = row.map((node) => node.textContent || '').join(' ').toLowerCase();
        const iconClass = rowText.includes('email') || rowText.includes('@') ? 'email' : rowText.includes('location') || rowText.includes('address') ? 'location' : 'default';

        item.className = `cont_bottom__item cont_bottom__item--${iconClass}`;
        row.forEach((node) => item.appendChild(node));
        items.appendChild(item);
      });

      paragraph.replaceWith(items);
    });

    container.dataset.contactBottomReady = 'true';
  });
};

document.addEventListener('DOMContentLoaded', () => initContactBottomIcons());
document.addEventListener('shopify:section:load', (event) => initContactBottomIcons(event.target));

const initFooterScrollTop = (root = document) => {
  const buttons = Array.from(root.querySelectorAll('[data-scroll-top]'));

  if (!buttons.length) {
    return;
  }

  const toggleScrollTopButtons = () => {
    const isVisible = window.scrollY > 420;

    document.querySelectorAll('[data-scroll-top]').forEach((button) => {
      button.classList.toggle('is-visible', isVisible);
    });
  };

  buttons.forEach((button) => {
    if (button.dataset.scrollTopReady === 'true') {
      return;
    }

    button.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });

    button.dataset.scrollTopReady = 'true';
  });

  if (window.customScrollTopReady !== true) {
    window.addEventListener('scroll', toggleScrollTopButtons, { passive: true });
    window.addEventListener('resize', toggleScrollTopButtons);
    window.customScrollTopReady = true;
  }

  toggleScrollTopButtons();
};

document.addEventListener('DOMContentLoaded', () => initFooterScrollTop());
document.addEventListener('shopify:section:load', (event) => initFooterScrollTop(event.target));

const syncHiddenProductCardParents = (root = document) => {
  const hiddenParentClass = 'product-grid__item--hidden-by-card';
  const gridItems = root.querySelectorAll('#product-grid .grid__item');

  gridItems.forEach((item) => {
    const productCard = item.querySelector('.product-card-wrapper');

    if (!productCard) {
      return;
    }

    item.classList.remove(hiddenParentClass);

    const isProductCardHidden =
      productCard.hidden ||
      productCard.classList.contains('hidden') ||
      productCard.style.display === 'none' ||
      window.getComputedStyle(productCard).display === 'none';

    item.classList.toggle(hiddenParentClass, isProductCardHidden);
  });
};

const initHiddenProductCardParentSync = () => {
  syncHiddenProductCardParents();

  if (window.hiddenProductCardParentSyncReady === true) {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    const shouldSync = mutations.some((mutation) => {
      const target = mutation.target;

      if (target.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return (
        target.matches?.('#product-grid, #product-grid *, .product-card-wrapper') ||
        Array.from(mutation.addedNodes).some((node) => node.nodeType === Node.ELEMENT_NODE && node.querySelector?.('#product-grid, .product-card-wrapper'))
      );
    });

    if (shouldSync) {
      window.requestAnimationFrame(() => syncHiddenProductCardParents());
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
  });

  window.hiddenProductCardParentSyncReady = true;
};

document.addEventListener('DOMContentLoaded', initHiddenProductCardParentSync);
document.addEventListener('shopify:section:load', initHiddenProductCardParentSync);

const initCustomRevealAnimations = (root = document) => {
  const genericTextSelector = [
    '.common-title',
    '.title',
    '.uppertitle',
    '.inline-richtext',
    '.rte',
    '.collection__description',
    '.image-with-text__heading',
    '.image-with-text__text',
    '.multicolumn-card__info h3',
    '.multicolumn-card__info .rte',
    '.card__heading',
    '.product-card-subheading',
    '.card-information > .price',
    '.shop-prod',
    '.eo-badge',
    '.eo-feature-title',
    '.eo-feature-subtitle',
    '.eo-description',
    '.feature-item h3',
    '.feature-item p',
    '.custom-faq__title',
    '.custom-faq__text',
    '.rich-text__heading',
    '.rich-text__text',
    '.banner__heading',
    '.banner__text',
    '.button',
    '.link-button',
  ].join(', ');

  const revealGroups = [
    {
      sectionSelector: '.shopify-section, section, .essential-oils',
      itemSelector: genericTextSelector,
    },
    {
      sectionSelector: '[data-custom-banner]',
      itemSelector:
        '.custom-banner__slider--single .custom-banner__title, .custom-banner__slider--single .custom-banner__text, .custom-banner__slider--single .custom-banner__subtitle, .custom-banner__slider--single .custom-banner__buttons, .custom-banner__slide.is-active .custom-banner__title, .custom-banner__slide.is-active .custom-banner__text, .custom-banner__slide.is-active .custom-banner__subtitle, .custom-banner__slide.is-active .custom-banner__buttons',
    },
    {
      sectionSelector: '.ftr-clctn',
      itemSelector:
        'h4.uppertitle, .common-title, .collection__description, .top-btn, .product-card-wrapper > .card > .card__content .card__heading, .product-card-wrapper > .card > .card__content .product-card-subheading, .product-card-wrapper > .card > .card__content .card-information > .price, .product-card-wrapper > .card > .card__content .shop-prod',
    },
    {
      sectionSelector: '.essential-oils',
      itemSelector:
        '.eo-badge, .eo-feature-title, .eo-feature-subtitle, .eo-content .common-title, .eo-description, .eo-card',
    },
    {
      sectionSelector: '.community-range',
      itemSelector:
        '.community-range__reviews .eyebrow, .community-range__reviews .section-header h2, .community-range__reviews .description, .community-range__reviews .review-card, .community-range__reviews .button, .community-range__products .eyebrow, .community-range__products .section-header h2, .community-range__products .description, .community-range__products .product-info h4, .community-range__products .product-info span, .community-range__products .product-info strong, .community-range__products .button',
    },
    {
      sectionSelector: '.feature-column-banner',
      itemSelector: '.feature-item h3, .feature-item p',
    },
    {
      sectionSelector: '.stocklist-text',
      itemSelector:
        '.rich-text__caption, .rich-text__heading, .rich-text__text, .rich-text__buttons, .rich-text__buttons .button',
    },
    {
      sectionSelector: '.contact-banner-section',
      itemSelector:
        '.contact-banner-content h2, .contact-banner-content h3, .contact-banner-content .rte, .contact-banner-form h2, .contact-banner-form .form-subheading, .contact-banner-form .field__labels, .contact-banner-form .field__input, .contact-banner-form .text-area, .contact-banner-form .contact__button',
    },
    {
      sectionSelector: '.custom-faq-section',
      itemSelector:
        '.faq-subtitle, .faq-title, .faq-item, .faq-question span:first-child, .faq-answer-inner',
    },
    {
      sectionSelector: '.stockist-section',
      itemSelector:
        '.stockist-content .stockist-title, .stockist-content .stockist-description, .stockist-content .stockist-form',
    },
    {
      sectionSelector: '[data-custom-story-intro]',
      itemSelector:
        '.custom-story-intro__subheading, .custom-story-intro__heading, .custom-story-intro__text, .custom-story-intro__features, .custom-story-intro__button',
    },
  ];

  const revealMap = new Map();

  revealGroups.forEach(({ sectionSelector, itemSelector }) => {
    root.querySelectorAll(sectionSelector).forEach((section) => {
      if (
        section.closest(
          'header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group, .custom-announcement-bar-section'
        )
      ) {
        return;
      }

      if (!revealMap.has(section)) {
        revealMap.set(section, new Set());
      }

      section.querySelectorAll(itemSelector).forEach((item) => {
        if (
          item.closest(
            'header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group, .custom-announcement-bar-section'
          )
        ) {
          return;
        }

        revealMap.get(section).add(item);
      });
    });
  });

  const sections = Array.from(revealMap.entries()).map(([section, items]) => ({
    section,
    items: Array.from(items).filter((item, index, allItems) => !allItems.some((other) => other !== item && other.contains(item))),
  }));

  if (!sections.length) {
    return;
  }

  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach(({ section }) => {
      section.classList.add('is-custom-reveal-visible');
    });
    return;
  }

  sections.forEach(({ section, items }) => {
    if (section.dataset.customRevealReady === 'true') {
      return;
    }

    section.dataset.customRevealReady = 'true';
    let essentialOilCardIndex = 0;
    const isMobileReveal = window.matchMedia('(max-width: 749px)').matches;

    items.forEach((item, index) => {
      const isEssentialOilCard = section.classList.contains('essential-oils') && item.classList.contains('eo-card');
      const revealDelay = isEssentialOilCard
        ? isMobileReveal
          ? Math.min(essentialOilCardIndex++ * 0.04, 0.12)
          : Math.min(0.18 + essentialOilCardIndex++ * 0.18, 0.9)
        : Math.min(0.16 + index * 0.1, 0.8);

      item.classList.add('custom-reveal-item');
      item.dataset.customRevealOrder = index;
      item.style.setProperty('--custom-reveal-delay', `${revealDelay.toFixed(2)}s`);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-custom-reveal-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: window.matchMedia('(max-width: 749px)').matches ? '0px 0px -4% 0px' : '0px 0px -22% 0px',
      threshold: window.matchMedia('(max-width: 749px)').matches ? 0.06 : 0.28,
    }
  );

  sections.forEach(({ section }) => {
    if (!section.classList.contains('is-custom-reveal-visible')) {
      observer.observe(section);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initCustomRevealAnimations());
document.addEventListener('shopify:section:load', (event) => initCustomRevealAnimations(event.target));

let customAboutParallaxTicking = false;

const updateAboutImageParallax = () => {
  const sections = document.querySelectorAll('.abt-fml, .abt-farm, .abt-oil');
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

  sections.forEach((section) => {
    const image = section.querySelector('.image-with-text__media img');

    if (!image) {
      return;
    }

    const rect = section.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > viewportHeight) {
      return;
    }

    const progress = Math.min(Math.max((viewportHeight - rect.top) / (viewportHeight + rect.height), 0), 1);
    const offset = (0.5 - progress) * 76;

    image.style.setProperty('--about-image-parallax-y', `${offset.toFixed(2)}px`);
  });

  customAboutParallaxTicking = false;
};

const requestAboutImageParallaxUpdate = () => {
  if (customAboutParallaxTicking) {
    return;
  }

  customAboutParallaxTicking = true;
  window.requestAnimationFrame(updateAboutImageParallax);
};

const initAboutImageParallax = () => {
  const sections = document.querySelectorAll('.abt-fml, .abt-farm, .abt-oil');

  if (!sections.length) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    sections.forEach((section) => {
      section.querySelectorAll('.image-with-text__media img').forEach((image) => {
        image.style.removeProperty('--about-image-parallax-y');
      });
    });
    return;
  }

  if (window.customAboutParallaxReady !== true) {
    window.addEventListener('scroll', requestAboutImageParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestAboutImageParallaxUpdate);
    window.customAboutParallaxReady = true;
  }

  requestAboutImageParallaxUpdate();
};

document.addEventListener('DOMContentLoaded', initAboutImageParallax);
document.addEventListener('shopify:section:load', initAboutImageParallax);



const initCustomStoryIntroSections = () => {
  const sections = document.querySelectorAll('[data-custom-story-intro]');

  sections.forEach((section) => {
    const slider = section.querySelector('[data-custom-story-features]');

    if (!slider || typeof Splide === 'undefined' || slider.classList.contains('is-initialized')) {
      return;
    }

    const slideCount = slider.querySelectorAll('.splide__slide').length;

    if (slideCount <= 1) {
      return;
    }

    new Splide(slider, {
      type: 'slide',
      arrows: false,
      pagination: false,
      drag: true,
      perPage: Math.min(slideCount, 4),
      perMove: 1,
      gap: 0,
      keyboard: false,
      breakpoints: {
        989: {
          perPage: Math.min(slideCount, 4),
        },
        749: {
          perPage: Math.min(slideCount, 2),
        },
        479: {
          perPage: 1,
          pagination: true,
        },
      },
    }).mount();
  });
};

document.addEventListener('DOMContentLoaded', initCustomStoryIntroSections);
document.addEventListener('shopify:section:load', initCustomStoryIntroSections);
